import { Link } from 'react-router-dom';
import { SearchBar } from '../../../SearchBar';
import { UserInfo } from '../UserInfo/UserInfo';
import { SoundToggleButton } from '../../../SoundToggleButton/SoundToggleButton';
import { NotificationCenter } from '../../../NotificationCenter/NotificationCenter';
import './header.css';
import WitheBurgerMenu from '../../../../assets/icon/components/WitheBurgerMenu';
interface PageWrapperHeaderProps {
  onBurgerMenuClick: () => void;
  isMobile: boolean;
}

export const PageWrapperHeader: React.FC<PageWrapperHeaderProps> = ({
  onBurgerMenuClick,
  isMobile
}) => {
  return (
    <header className="header-menu">
      <div className="header-main-row">
        {isMobile ? (
          <>
            <button className="header-burger-btn" onClick={onBurgerMenuClick}>
              <WitheBurgerMenu width={24} height={24} color="#fff" />
            </button>
            <SearchBar
              differentClickAction="headerSearch"
              isMobile={isMobile}
            />
            <SoundToggleButton />
            <NotificationCenter />
            <UserInfo />
          </>
        ) : (
          <>
            <Link className="header-brand" to="/">
              Parfumart Admin
            </Link>
            <SearchBar
              differentClickAction="headerSearch"
              isMobile={isMobile}
            />
            <SoundToggleButton />
            <NotificationCenter />
            <UserInfo />
          </>
        )}
      </div>
    </header>
  );
};
